import {
  SingleSelectButtonGroup,
  SingleSelectButtonGroupData,
  SingleSelectButtonGroupHandler,
} from '../SingleSelectButtonGroup';
import variants from '@services/MarppleShop/shared/components/atoms/SectionTabs/SectionTabs.module.scss';
import { font } from '@services/MarppleShop/shared/typography';

/**
 * @deprecated
 * @see {SectionTabs}
 * 가능하면 SectionTabs 의 bubble 속성을 사용해주세요
 */
export const createCategoryButtonGroupView = <T>(
  data: SingleSelectButtonGroupData<T>,
  handlers: SingleSelectButtonGroupHandler<T> = {},
  options: {
    /**
     * @default 'lg'
     */
    size?: 'xl' | 'lg' | 'xs';
  } = {},
): SingleSelectButtonGroup<T> => {
  const sizeMap = {
    xl: variants.large,
    lg: variants.medium,
    xs: variants.small,
  };

  const size = (options.size && sizeMap[options.size]) ?? sizeMap.lg;
  const typo = options.size === 'xl' ? font('18_medium') : font('14_medium');

  return new SingleSelectButtonGroup(data, {
    container_class: `${variants.tabs} ${variants.bubble} ${size}`,
    button_class: `${variants.tab} ${typo}`,
    active_class: variants.active,
    ...handlers,
  });
};
